import { Textarea } from "@/components/ui/textarea";
import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import TargetQuestionsDialog from "@/src/console/(auth)/_components/EvaluationReport/SdgIndicatorCard/TargetQuestionsDialog";
import { QuestionCircle20Regular } from "@fluentui/react-icons";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface EvaluationRowProps {
  goalId: number;
  goalIndex: number;
  targetIndex: number;
}

function EvaluationRow({ goalId, goalIndex, targetIndex }: EvaluationRowProps) {
  const { t } = useTranslation();
  const { control } = useFormContext<EvaluationReport>();
  const {
    field: {
      value: {
        score,
        target_number: targetNumber,
        answer_contents,
        description,
      },
    },
  } = useController({
    control,
    name: `result_index.sdg_goal_results.${goalIndex}.sdg_target_results.${targetIndex}`,
  });

  const {
    field: { value: evaluationNote, onChange },
  } = useController({
    control,
    name: `result_index.sdg_goal_results.${goalIndex}.sdg_target_results.${targetIndex}.evaluation_note`,
  });
  return (
    <>
      <div className=" flex flex-row space-x-6 px-4 py-6 items-center">
        <div className=" flex flex-col space-y-[2px] w-[128px]">
          <div className=" flex flex-row space-x-[2px] items-center">
            <p className=" text-sm font-medium text-cool-gray-700">
              {t("target")} {goalId}.{targetNumber}
            </p>
            <QuestionCircle20Regular />
          </div>

          <TargetQuestionsDialog
            target={`${goalId}.${targetNumber}`}
            description={description}
            answerContents={answer_contents}
          />
        </div>
        <div className=" flex flex-col space-y-[2.5] w-[96px]">
          <p className=" text-sm font-medium text-cool-gray-700">
            {score ? score : "--"}
          </p>
          <p className=" text-sm font-normal text-cool-gray-500">
            {t("points")}
          </p>
        </div>
        <Textarea
          value={evaluationNote ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className=" flex-grow resize-none h-[58px]"
          placeholder="Enter evaluation note"
        />
      </div>
    </>
  );
}

export default EvaluationRow;
